module.exports = __webpack_public_path__ + "1.5.0-unryo/img/online-database-2.b2c16b5b.svg";